<!-- C:\VUE3\platform\src\components\common\AuthMenu.vue -->
<template>
  <!-- 로그인 전 -->
  <li v-if="!isLogin" class="nav-item">
    <button type="button" class="nav-link btn d-flex align-items-center" aria-label="로그인" @click="$emit('login')">
      <i class="bi bi-person-circle me-1 fs-5" aria-hidden="true"></i>
      <span class="d-none d-md-inline">Login</span>
    </button>
  </li>

  <!-- 로그인 후 -->
  <li v-else class="nav-item dropdown" data-bs-display="static">
    <!-- ✅ SEO: aria-haspopup, 동적 aria-label 추가 -->
    <button ref="userMenuButton" class="nav-link btn d-flex align-items-center" type="button" id="userMenuButton"
      data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="true" :aria-label="`${displayName} 사용자 메뉴`">
      <span
        class="me-2 d-inline-flex align-items-center justify-content-center rounded-circle overflow-hidden position-relative"
        style="width: 28px; height: 28px; overflow: visible !important;"
      >
        <img
          v-if="photoUrl"
          :src="photoUrl"
          alt=""
          width="28"
          height="28"
          aria-hidden="true"
          class="rounded-circle"
        />
        <i v-else class="bi bi-person-circle fs-5" aria-hidden="true"></i>

        <span
          class="position-absolute top-0 start-100 translate-middle p-1 border border-light rounded-circle"
          :class="unreadCount > 0 ? 'bg-danger' : ''"
          :style="{
            minWidth: '18px',
            height: '18px',
            transform: 'translate(-35%, 35%)',
            backgroundColor: unreadCount > 0 ? undefined : 'var(--bs-primary)',
          }"
          :aria-label="unreadCount > 0 ? '새로운 알림 있음' : '새로운 알림 없음'"
          role="status"
        >
          <span
            class="d-flex align-items-center justify-content-center text-white fw-semibold"
            style="font-size: 0.65rem; line-height: 1;"
            aria-hidden="true"
          >
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </span>
          <span class="visually-hidden">
            {{ unreadCount > 0 ? `새로운 알림 ${unreadCount}개` : '새로운 알림 없음' }}
          </span>
        </span>
      </span>

      <div class="d-none d-md-flex flex-column align-items-start user-info-block">
        <span class="text-truncate user-name" style="max-width: 140px">
          {{ displayName }}
        </span>
      </div>
    </button>

    <!-- ✅ SEO: role="menu" 추가 -->
    <div class="dropdown-menu dropdown-menu-end p-0 shadow" aria-labelledby="userMenuButton" role="menu"
      style="width: 380px; max-width: 90vw; border-radius: 1rem">
      <!-- 상단 정보 -->
      <div class="p-3 border-bottom bg-body-tertiary">
        <div class="d-flex align-items-center gap-3">
          <div class="rounded-circle overflow-hidden d-inline-flex" style="width: 56px; height: 56px"
            aria-hidden="true">
            <img v-if="photoUrl" :src="photoUrl" alt="" class="w-100 h-100 object-fit-cover" />
            <div v-else class="bg-secondary text-white d-flex align-items-center justify-content-center w-100 h-100">
              <i class="bi bi-person-fill fs-3" aria-hidden="true"></i>
            </div>
          </div>
          <div class="flex-grow-1 overflow-hidden">
            <div class="fw-semibold text-truncate">{{ displayName }}님</div>
            <div class="small text-body-secondary text-truncate" :title="email">
              {{ email }}
            </div>
            <div v-if="tenantName" class="small text-body-secondary text-truncate">
              {{ tenantName }}
            </div>
            <!-- ✅ SEO: 세션 타이머 aria-live 추가 -->
            <div v-if="showSessionTimer" class="small mt-1" :class="sessionTimerClass" role="timer" aria-live="polite"
              aria-atomic="true" :aria-label="`세션 만료까지 ${formattedTime} 남음`">
              <i class="bi bi-clock me-1" aria-hidden="true"></i>
              <span>세션 만료: {{ formattedTime }}</span>
            </div>
          </div>
        </div>
        <div class="mt-3 d-flex gap-2 p-2">
          <button type="button" class="btn btn-primary btn-sm flex-grow-1" role="menuitem" @click="manageAccount">
            <i class="bi bi-gear me-1" aria-hidden="true"></i>
            계정 관리
          </button>
        </div>
      </div>

      <!-- 빠른 작업 -->
      <div class="p-2" role="group" aria-label="빠른 작업">
        <div class="row g-2">
          <div class="col-12">
            <button type="button" class="btn btn-light w-100 d-flex align-items-center justify-content-between"
              role="menuitem" @click="mypage">
              <span>
                <i class="bi bi-person-square me-2" aria-hidden="true"></i>
                마이페이지
              </span>
              <i class="bi bi-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
          <div class="col-12">
            <button type="button" class="btn btn-light w-100 d-flex align-items-center justify-content-between"
              role="menuitem" @click="cart">
              <span>
                <i class="bi bi-cart3 me-2" aria-hidden="true"></i>
                장바구니
              </span>
              <i class="bi bi-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
          <div class="col-12">
            <button type="button" class="btn btn-light w-100 d-flex align-items-center justify-content-between"
              role="menuitem" @click="openNotifications">
              <span class="d-flex align-items-center">
                <span class="position-relative me-2">
                  <i class="bi bi-bell fs-5" aria-hidden="true"></i>
                  <!-- 읽지 않은 알림 뱃지 -->
                  <span v-if="unreadCount > 0"
                    class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style="font-size: 0.6rem">
                    {{ unreadCount > 99 ? '99+' : unreadCount }}
                  </span>
                </span>
                알림
              </span>
              <i class="bi bi-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- 푸터 -->
      <div class="d-flex align-items-center justify-content-end p-2 border-top bg-body-tertiary">
        <button type="button" class="btn btn-outline-danger btn-sm" role="menuitem" @click="openLogoutModal">
          <i class="bi bi-box-arrow-right me-1" aria-hidden="true"></i>
          로그아웃
        </button>
      </div>
    </div>
  </li>

  <!-- ✅ 로그아웃 확인 모달 -->
  <Teleport to="body">
    <div v-if="isModalMounted" ref="logoutModalRef" class="modal fade" tabindex="-1" aria-labelledby="logoutModalLabel"
      :aria-hidden="!isModalMounted" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <!-- ✅ SEO: span → h2 시맨틱 개선 -->
            <h2 id="logoutModalLabel" class="modal-title h6">
              <i class="bi bi-box-arrow-right me-2" aria-hidden="true"></i>
              {{ $t("logout.title", "로그아웃") }}
            </h2>
            <button type="button" class="btn-close" aria-label="모달 닫기" @click="closeLogoutModal" />
          </div>

          <div class="modal-body py-3">
            <p class="mb-3">
              {{ $t("logout.confirmMessage", "로그아웃 하시겠습니까?") }}
            </p>

            <div class="alert alert-warning d-flex align-items-start py-2 mb-0" role="alert">
              <i class="bi bi-exclamation-triangle-fill me-2 flex-shrink-0" style="margin-top: 2px"
                aria-hidden="true"></i>
              <div class="small">
                {{
                  $t(
                    "logout.dataWarningMessage",
                    "로그아웃 시 현재 브라우저에 저장된 임시 데이터(작성 중인 내용, 검색 필터 등)가 삭제됩니다.",
                  )
                }}
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-outline-secondary btn-sm" @click="closeLogoutModal">
              {{ $t("common.cancel", "취소") }}
            </button>
            <!-- ✅ SEO: aria-busy 추가 -->
            <button type="button" class="btn btn-danger btn-sm" :disabled="isLoggingOut" :aria-busy="isLoggingOut"
              @click="confirmLogout">
              <span v-if="isLoggingOut" class="spinner-border spinner-border-sm me-1" role="status"
                aria-hidden="true"></span>
              <span v-if="isLoggingOut" class="visually-hidden">로그아웃 중...</span>
              {{ $t("logout.confirm", "로그아웃") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import {
  computed,
  ref,
  onMounted,
  onBeforeUnmount,
  inject,
  nextTick,
} from "vue";

import Dropdown from "bootstrap/js/dist/dropdown";
import Modal from "bootstrap/js/dist/modal";
import { useAlertsStore } from "@/store/notifications/useAlertsStore";

const props = defineProps({
  isLogin: { type: Boolean, default: false },
  user: { type: Object, default: () => ({}) },
  language: { type: String, default: "ko" },
  country: { type: String, default: "KR" },
  currency: { type: String, default: "KRW" },
  unreadCount: { type: Number, default: 0 },
});

const emit = defineEmits([
  "login",
  "logout",
  "switch-theme",
  "settings-updated",
  "open-language",
  "open-admin",
  "open-preferences",
  "open-help",
  "open-notifications",
  "open-saved",
  "cart",
  "mypage",
  "manage-account",
  "add-account",
]);

const alertsStore = useAlertsStore();
const unreadCount = computed(() => props.unreadCount);
const userMenuButton = ref(null);
const logoutModalRef = ref(null);
const isLoggingOut = ref(false);
const isModalMounted = ref(false);
const pendingLogout = ref(false);

let dropdownInstance = null;
let logoutModalInstance = null;

/* ==============================
 *  세션 타이머
 * ============================== */
const sessionTimer = inject("sessionTimer", null);

const showSessionTimer = computed(() => {
  return props.isLogin && sessionTimer?.isActive?.value;
});

const remainingMs = computed(() => {
  return sessionTimer?.remainingTime?.value ?? 0;
});

const formattedTime = computed(() => {
  if (sessionTimer?.remainingFormatted?.value) {
    return sessionTimer.remainingFormatted.value;
  }

  const ms = remainingMs.value;
  if (ms <= 0) return "00:00";

  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
});

const isWarning = computed(() => {
  return sessionTimer?.isWarningVisible?.value ?? false;
});

const sessionTimerClass = computed(() => ({
  "text-danger": isWarning.value,
  "text-warning": !isWarning.value && remainingMs.value < 5 * 60 * 1000,
  "text-muted": !isWarning.value && remainingMs.value >= 5 * 60 * 1000,
  "timer-warning": isWarning.value,
}));

/* ==============================
 *  사용자 정보 Computed
 * ============================== */
const email = computed(() => props.user?.email || props.user?.userEmail || "");
const displayName = computed(
  () =>
    props.user?.displayName ||
    (email.value ? email.value.split("@")[0] : "사용자"),
);
const tenantName = computed(() => props.user?.tenantName || "");
const roles = computed(() => props.user?.roles || []);
const isAdmin = computed(
  () => Array.isArray(roles.value) && roles.value.includes("ADMIN"),
);
const photoUrl = computed(() => props.user?.photoUrl || "");

/* ==============================
 *  로그아웃 모달 메서드
 * ============================== */
async function openLogoutModal() {
  dropdownInstance?.hide();
  isModalMounted.value = true;

  await nextTick();

  if (logoutModalRef.value && !logoutModalInstance) {
    logoutModalInstance = new Modal(logoutModalRef.value, {
      backdrop: true,
      keyboard: true,
    });

    logoutModalRef.value.addEventListener("hidden.bs.modal", onModalHidden);
  }

  logoutModalInstance?.show();
}

function closeLogoutModal() {
  logoutModalInstance?.hide();
}

function confirmLogout() {
  if (isLoggingOut.value) return;

  isLoggingOut.value = true;
  pendingLogout.value = true;

  closeLogoutModal();
}

function onModalHidden() {
  if (logoutModalInstance) {
    logoutModalInstance.dispose();
    logoutModalInstance = null;
  }

  isModalMounted.value = false;

  if (pendingLogout.value) {
    pendingLogout.value = false;
    isLoggingOut.value = false;
    emit("logout");
  }
}

/* ==============================
 *  라이프사이클
 * ============================== */
onMounted(() => {
  if (userMenuButton.value) {
    dropdownInstance = new Dropdown(userMenuButton.value);
  }
});

onBeforeUnmount(() => {
  dropdownInstance?.dispose();
  dropdownInstance = null;

  if (logoutModalInstance) {
    try {
      const modalEl = logoutModalRef.value;
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", onModalHidden);

        const backdrop = document.querySelector(".modal-backdrop");
        backdrop?.remove();

        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("overflow");
        document.body.style.removeProperty("padding-right");
      }

      logoutModalInstance.dispose();
    } catch (e) {
      // 무시
    }
    logoutModalInstance = null;
  }

  isModalMounted.value = false;
});

/* ==============================
 *  네비게이션 메서드
 * ============================== */
const cart = () => emit("cart");
const board = () => emit("open-help");
const openAdmin = () => emit("open-admin");
const mypage = () => emit("mypage");
const manageAccount = () => emit("manage-account");
const openNotifications = () => {
  dropdownInstance?.hide();
  emit("open-notifications");
};
const openSaved = () => emit("open-saved");
</script>

<style scoped>
.object-fit-cover {
  object-fit: cover;
}

.user-info-block {
  line-height: 1.2;
  min-width: 80px;
}

.user-name {
  font-size: 0.9rem;
  font-weight: 500;
  color: inherit;
}

.session-timer {
  font-size: 0.7rem;
  font-family: "Consolas", "Monaco", "Courier New", monospace;
  display: inline-flex;
  align-items: center;
  padding: 1px 4px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.04);
  margin-top: 2px;
}

.session-timer.text-muted {
  background-color: rgba(108, 117, 125, 0.1);
}

.session-timer.text-warning {
  background-color: rgba(255, 193, 7, 0.15);
  color: #856404 !important;
}

.session-timer.text-danger {
  background-color: rgba(220, 53, 69, 0.1);
}

.session-timer.timer-warning {
  animation: pulse-warning 1s ease-in-out infinite;
}

@keyframes pulse-warning {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

/* ✅ SEO: 스크린리더 전용 텍스트 */
.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>
